"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyDataInIvrFailureEvent = exports.VerifyDataInIvrSuccessEvent = exports.RaiseN2IVRErrorEvent = exports.RaiseN2IVRSuccessEvent = exports.RaiseN2OTPIVRErrorEvent = exports.RaiseN2OTPIVRSuccessEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class RaiseN2OTPIVRSuccessEvent extends web_ui_framework_1.Event {
}
exports.RaiseN2OTPIVRSuccessEvent = RaiseN2OTPIVRSuccessEvent;
class RaiseN2OTPIVRErrorEvent extends web_ui_framework_1.Event {
}
exports.RaiseN2OTPIVRErrorEvent = RaiseN2OTPIVRErrorEvent;
class RaiseN2IVRSuccessEvent extends web_ui_framework_1.Event {
}
exports.RaiseN2IVRSuccessEvent = RaiseN2IVRSuccessEvent;
class RaiseN2IVRErrorEvent extends web_ui_framework_1.Event {
}
exports.RaiseN2IVRErrorEvent = RaiseN2IVRErrorEvent;
class VerifyDataInIvrSuccessEvent extends web_ui_framework_1.Event {
}
exports.VerifyDataInIvrSuccessEvent = VerifyDataInIvrSuccessEvent;
class VerifyDataInIvrFailureEvent extends web_ui_framework_1.Event {
}
exports.VerifyDataInIvrFailureEvent = VerifyDataInIvrFailureEvent;
//# sourceMappingURL=ivrEvent.js.map